import { COPY } from '@/lib/copy';

type Props = {
  total: number;
  current: number;
  onSelect: (i: number) => void;
};

export default function CarouselDots({ total, current, onSelect }: Props) {
  return (
    <div
      className="mt-8 flex justify-center gap-2"
      role="group"
      aria-label={COPY.reviews.navLabel}
    >
      {Array.from({ length: total }).map((_, i) => (
        <button
          key={i}
          aria-label={COPY.reviews.groupLabel(i + 1, total)}
          aria-pressed={i === current}
          onClick={() => onSelect(i)}
          className={`w-2 h-2 rounded-full transition-colors duration-200 cursor-pointer ${
            i === current ? 'bg-primary' : 'bg-border hover:bg-color-text-light'
          }`}
        />
      ))}
    </div>
  );
}
